import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'

export const GET_PLAYLIST_REQUEST = 'GET_PLAYLIST_REQUEST'
export const GET_PLAYLIST_SUCCESS = 'GET_PLAYLIST_SUCCESS'
export const GET_PLAYLIST_ERROR = 'GET_PLAYLIST_ERROR'
export const getPlaylist = (id) => dispatch => {
	dispatch({ type: GET_PLAYLIST_REQUEST })
	return api.getPlaylist(id, 'tracks', 0, 50)
		.then(response => {
			if (response.status === 'error') {
				dispatch(push('/'))
				dispatch({ type: GET_PLAYLIST_ERROR, response })
			} else {
				dispatch({
					type: GET_PLAYLIST_SUCCESS,
					playlist: response
				})
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_PLAYLIST_ERROR, e })
		})
}



// WEBPACK FOOTER //
// ./src/pages/playlist/playlistActions.js